export const TENANT_USER_ROLES = {
  MEGA: 'MEGA',
  ADMIN_OWNER: 'ADMIN_OWNER',
  ADMIN: 'ADMIN',
  EDITOR: 'EDITOR',
  VIEWER: 'VIEWER'
};

export const TENANT_USER_ROLES_TRANSLATED = {
  MEGA: 'Mega',
  ADMIN_OWNER: 'Admin Owner',
  ADMIN: 'Admin',
  EDITOR: 'Editor',
  VIEWER: 'Viewer'
};

export const TENANT_USER_STATUS = {
  INVITED: 'INVITED',
  ACCEPTED: 'ACCEPTED'
};

export const TENANT_USER_STATUS_TRANSLATED = {
  INVITED: 'Invited',
  ACCEPTED: 'Accepted'
};
